import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

type CellState = 'yes' | 'no' | 'partial' | 'neutral';

interface CompareCell {
  state: CellState;
  /** Si se indica, se muestra el texto en lugar del icono. */
  text?: string;
}

interface CompareColumn {
  name: string;
  sub?: string;
  highlight?: boolean;
}

interface CompareRow {
  feature: string;
  detail?: string;
  /** Alineadas con `columns`. */
  cells: CompareCell[];
}

@Component({
  selector: 'app-por-que-nosotros',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './por-que-nosotros.component.html',
  styleUrl: './por-que-nosotros.component.scss',
})
export class PorQueNosotrosComponent {
  columns: CompareColumn[] = [
    { name: 'Fichaje suelto' },
    { name: 'Suite genérica' },
    { name: 'TodoSector', highlight: true },
  ];

  rows: CompareRow[] = [
    {
      feature: 'Fichaje y facturación conectados',
      cells: [{ state: 'no' }, { state: 'partial' }, { state: 'yes' }],
    },
    {
      feature: 'No pagas por quien solo ficha',
      cells: [{ state: 'no' }, { state: 'no' }, { state: 'yes' }],
    },
    {
      feature: 'Sin configuración compleja',
      cells: [{ state: 'yes' }, { state: 'no' }, { state: 'yes' }],
    },
    {
      feature: 'Puesta en marcha por un humano',
      cells: [{ state: 'no' }, { state: 'no' }, { state: 'yes' }],
    },
    {
      feature: 'Lo que no existe, a medida',
      cells: [{ state: 'no' }, { state: 'no' }, { state: 'yes' }],
    },
  ];
}
